import { render } from "./ChannelList.vue?vue&type=template&id=7382f748&scoped=true&ts=true"
import script from "./ChannelList.vue?vue&type=script&lang=ts"
export * from "./ChannelList.vue?vue&type=script&lang=ts"

import "./ChannelList.vue?vue&type=style&index=0&id=7382f748&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7382f748"]])

export default __exports__